import { FC } from "react";
import { useQuery } from "@tanstack/react-query";
import { landlordSurveyApi } from "api/landlord-surveys/landlord-surveys";
import {
  IconButton,
  IconButtonSize,
  IconButtonVariant,
  Modal,
  TextSkeleton
} from "shared/components";
import { Cancel01Icon } from "@hugeicons-pro/core-stroke-rounded";
export const SurveyPreviewBasicModal: FC<{
  id?: string;
  onClose: () => void;
  questionCount: number;
  questions?: string[];
  templateName?: string;
}> = ({ id, onClose, questionCount, questions: _questions, templateName }) => {
  const { data: survey, isLoading: isQueryLoading } = useQuery({
    queryFn: () => landlordSurveyApi.getSurveyByIdentifier(String(id)),
    queryKey: ["LANDLORD_SURVEY", id],
    enabled: Boolean(id)
  });

  const isLoading = _questions ? false : isQueryLoading;
  const questions = _questions
    ? _questions
    : (survey?.questions || []).map((q) => q.question);

  return (
    <Modal
      opened={true}
      onClose={onClose}
      panelClassName="w-full max-w-[600px] max-h-[90vh]"
    >
      <header className="h-[72px] flex items-center justify-between px-6 border-b border-alpha-100">
        <h2 className="text-xl font-bold text-content-1000">
          {isLoading ? (
            <TextSkeleton size="xl" />
          ) : (
            survey?.name || templateName || "Survey Preview"
          )}
        </h2>
        <IconButton
          size={IconButtonSize.SM}
          variant={IconButtonVariant.TEXT_BASE}
          HugeIcon={Cancel01Icon}
          onClick={onClose}
        />
      </header>

      <div className="space-y-6 p-6 bg-background-900 rounded-b-lg">
        {isLoading
          ? Array(questionCount)
              .fill(null)
              .map((_, idx) => <TextSkeleton size="sm" key={idx} />)
          : questions.map((question, idx) => (
              <p key={idx} className="text-sm font-bold text-content-300">
                {question}
              </p>
            ))}
      </div>
    </Modal>
  );
};
